import { Box } from "grommet"
import React from "react"
import { useParams } from "react-router-dom"
import Copyright from "../../../components/layout/Copyright"
import { GrommetRoot } from "../../../components/layout/GrommetRoot"
import { useDinoPaperQuery } from "../../../generated-types"

export const DinoLayout: React.FC<React.PropsWithChildren> = (props) => {
  const { paperId } = useParams()
  const { data } = useDinoPaperQuery({ variables: { paperId } })
  return (
    <GrommetRoot>
      <style>{"body { background-color: #4F46E5; margin-bottom: 20px}"}</style>
      <Box
        fill
        align="center"
        justify="start"
        overflow="scroll"
        background={{ color: "brand" }}
        pad={{ top: "20px", left: "20px", right: "20px" }}
      >
        <Box
          fill
          width="large"
          style={{ minHeight: "calc(100vh - 150px)" }}
          align="center"
          background={{ color: "white" }}
          round="10px"
          pad="20px"
          gap="small"
        >
          {props.children}
        </Box>
        <Box>
          <Copyright owner={data?.dinoPaper?.item?.owner} />
        </Box>
      </Box>
    </GrommetRoot>
  )
}
